import { GetShouldAssignParticipantInCategory } from './types/getShouldAssignParticipantInCategory.types'
import {
  getIsCategoryPickerVisible,
  getIsParticipantAgeValidForCategory
} from '.'

export const getShouldAssignParticipantInCategory: GetShouldAssignParticipantInCategory = (
  birthdate,
  category,
  packageConf,
  checkoutDate
) => (
  getIsCategoryPickerVisible(category, packageConf) &&
  getIsParticipantAgeValidForCategory(birthdate, packageConf[category], checkoutDate)
)
